import { GetStaticPaths } from "next";

import Post from "../../components/Releases/Post";
import Head from "next/head";
import {
  createGetStaticPathsFunction,
  getStaticPropsForPostPage as getStaticProps,
  PostPageProps,
  PostType,
} from "../../utils/posts";
import { FlashPCBPage } from "../../models/page";

const BlogPostPage: FlashPCBPage<PostPageProps> = ({ post }) => {
  return (
    <>
      <Head>
        <title>{post.title}</title>
        <meta
          name="description"
          content={post.subtitle || "FlashPCB blog post"}
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Post post={post} />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = createGetStaticPathsFunction(
  PostType.BLOG,
);

export { getStaticProps };

export default BlogPostPage;
